var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{on:{"mouseover":function($event){return _vm.mouseOverPixel()},"mouseout":function($event){return _vm.mouseOutPixel()},"&click":function($event){return _vm.$emit('click', $event)}}},[_c('v-rect',{ref:"bk",attrs:{"config":{
      x: _vm.x,
      y: _vm.y,
      width: _vm.width,
      height: _vm.height,
      fill: _vm.bkColor,
      stroke: _vm.strokeColor,
      strokeWidth: 0.05,
    }}}),_c('v-text',{ref:"text",attrs:{"config":{
      x: _vm.x,
      y: _vm.y,
      width: _vm.width,
      height: _vm.height,
      fill: _vm.textColor,
      align: 'center',
      fontSize: _vm.fontSize,
      fontFamily: 'icomoon',
      lineHeight: 0,
      verticalAlign: 'middle',
      text: _vm.getIcon(_vm.glyph),
      rotation: _vm.rotation,
      offsetX: _vm.offset.x,
      offsetY: _vm.offset.y,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }